import { Stack } from "@carbon/react";
import { CardComponent, CardRow } from "../../../components/Layouts/Card.styles";
import { HeatMap } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import Card from '../../../components/Layouts/Card';
import { Iframe } from "../../../components/Basics/Iframe.styles";
import InformationContainer from "../../../components/Basics/Information.container";

const Punctures = () => {
    return (
        <Stack gap={3}>
            <CardComponent width="100%">
                <Card justifyContent='flex-start' >
                    <HeatMap size={18} />
                    <Typography className='cds--type-heading-compact-01'>
                        PINCHAZOS - MAPA DE CALOR
                    </Typography>
                </Card>
                <InformationContainer description="El umbral para detección de un pinchazo es de 20 psi." />
                <CardRow width='inherit'>
                    <Card width='100%' padding="0">
                        <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/f072c3af-d693-4942-8948-7572a58a7c0f/pinchazos-tiempo-real?orgId=1&from=1705162992134&to=1705184592134&kiosk" width="100%" height="100%" />
                    </Card>
                </CardRow>
            </CardComponent>
        </Stack>
    )
};

export default Punctures;